package com.loyola.acessoescola.ui

import com.loyola.acessoescola.AppViewModel
import com.loyola.acessoescola.services.QuickAuthClient
import com.loyola.acessoescola.services.adminpanel.AdminPanelApi
import com.loyola.acessoescola.services.quintadb.AcessoEscolaAPI
import com.loyola.acessoescola.ui.addnew.AddNewViewModel
import com.loyola.acessoescola.ui.adminpanel.AdminPanelViewModel
import com.loyola.acessoescola.ui.login.LoginViewModel
import com.loyola.acessoescola.ui.registered.RegisteredViewModel

val acessoEscolaAPI = AcessoEscolaAPI()
fun createLoginViewModel(quickAuthClient: QuickAuthClient): LoginViewModel{
    return LoginViewModel(authClient = quickAuthClient)
}

fun createAppViewModel(quickAuthClient: QuickAuthClient): AppViewModel{
return AppViewModel(authClient = quickAuthClient)
}

fun createAddNewViewModel(quickAuthClient: QuickAuthClient): AddNewViewModel{
    return AddNewViewModel(
        acessoEscolaAPI = acessoEscolaAPI,
        quickAuthClient = quickAuthClient
    )
}

fun createRegisteredViwModel(quickAuthClient: QuickAuthClient): RegisteredViewModel{
    return RegisteredViewModel(
        acessoEscolaAPI = acessoEscolaAPI,
        quickAuthClient = quickAuthClient
    )
}

expect fun createAdminPanelViewModel(
    quickAuthClient: QuickAuthClient
): AdminPanelViewModel